import React from 'react';
// import {useSelector} from 'react-redux';
import UserID from './UserID';

const ToggleInput = ({handleToggle})=>{

     const [show,setShow] = React.useState(true);

     const cls = show ?'btn-outline-danger' :'btn-outline-danger';

     return (
        <>
            <span 
                className ={`btn  ${cls} btn-sm rounded mr-2 p-1 border-0`}
                style = {{position:'absolute',right:'14px',top:'-18px'}}
                onClick = {()=>{
                    setShow(!show);
                    handleToggle();
                }}
            > 
        
                { 
                    show 
                    ? (<>
                            <UserID />
                            <i className ='fa fa-times'></i>
                     </>)
                    : (<>
                           <UserID />
                           <i className ='fa fa-list'></i>
                      </>)
                }

            </span>
        </>
     );

};

export default ToggleInput;